// import React, { useState, useEffect, memo } from "react";
// import API from "api.js";
// import { store } from "store/index";
// import { useDispatch } from "react-redux";
// import { setUserType } from "action";
// import { Link } from "react-router-dom";
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
// import NotificationArea from "components/Dashboard/New/NotificationArea";
// import { fetchOnboardingData } from "components/WebsiteTour/tourData";
// import { isTourCompleted } from "components/WebsiteTour/tourData";
// // import CarRegistrationChart from "../components/Dashboard/DashboardChart";

// import StatCategories from "components/Dashboard/New/StatCategories";
// import Stats from "components/Dashboard/New/Stats";
// import TuteVideos from "components/Dashboard/TuteVideos";
// import EstimatedExamScore from "components/Dashboard/New/EstimatedExamScore";
// import UserSubscriptions from "components/Dashboard/UserSubscriptions.jsx";
// import UpcomingClasses from "components/Dashboard/UpcomingClasses.jsx";
// import TimezoneForm from "components/Dashboard/TimezoneForm";
// import Modal from "components/PopUps/Modal";
// // import DashboardTour from "components/WebsiteTour/DashboardTourShepherd";
// // import NavigationTour from "components/WebsiteTour/NavigationTourShepherd";
// import LaLoader from "components/Loader/LaLoader";

// const Dashboard = memo(function Dashboard(props) {
//   const [loading, setLoading] = useState(true);
//   const [practiceData, setPracticeData] = useState(null);
//   const [mockData, setMockData] = useState(null);
//   const [loggedInUser, setLoggedInUser] = useState(null);
//   const [portalVideos, setPortalVideos] = useState(null);
//   const [showAverageScore, setShowAverageScore] = useState(false);
//   const [estimatedScore, setEstimatedScore] = useState(0);
//   const [sectional_estimated, setSectionalEstimated] = useState({});
//   const [subscription, setSubscription] = useState([]);
//   const [classes, setClasses] = useState([]);
//   const [isTimezonePopup, setIsTimezonePopup] = useState(false);
//   const [examDatePopup, setExamDatePopup] = useState(false);
//   const [examDate, setExamDate] = useState(false);
//   const [showUserNamePopup, setShowUserNamePopup] = useState(false);
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [startDashboardTour, setStartDashboardTour] = useState(false);
//   const [dataLoaded, setDataLoaded] = useState(false);
//   const dispatch = useDispatch();

//   const loadDashboardData = () => {
//     API({
//       method: 'GET',
//       url: 'dashboard_data'
//     }).then(res => {
//       const { data, user, isClassified, branches, userType } = res.data;

//       const {
//         show_average_score,
//         estimated_score,
//         practice_data,
//         mock_data,
//         videos,
//         classes,
//         subscription,
//         popup_video,
//         sectional_estimated
//       } = data;
      
//       setExamDatePopup(mock_data.exam_date ? false : true)
//       setExamDate(mock_data.exam_date)
//       setSectionalEstimated(sectional_estimated)
//       setPracticeData(practice_data);
//       setMockData(mock_data);
//       setPortalVideos(videos);
//       setShowAverageScore(show_average_score);
//       setEstimatedScore(estimated_score);
//       setSubscription(subscription);
//       setClasses(classes);
//       // setShowUserNamePopup(!user.first_name || !user.last_name);
//       setShowUserNamePopup(!user.first_name);

//       setFirstName(user.first_name || '');
//       setLastName(user.last_name || '');
//       const isTimezoneSaved = !user.user_timezone ? true : false;
//       setIsTimezonePopup(isTimezoneSaved);


//       // Set logged in user info
//       let name = user.first_name
//         ? user.first_name + (user.last_name ? " " + user.last_name : "")
//         : user.email;
//       setLoggedInUser({
//         name,
//         email: user.email,
//         active_subscription: user.active_subscription,
//         session_expiry_date: user.session_expiry_date,
//       });
//        setDataLoaded(true);
//     }).catch(err => {
//       setDataLoaded(false);
//       console.log(err)});
//   }

//   useEffect(() => {
//     //  fetchOnboardingData(); 
//     const { user: { first_name, last_name, email, active_subscription, session_expiry_date } } = store.getState();

//     let name = first_name ? first_name : email;
//     setLoggedInUser({
//       name, email, active_subscription, session_expiry_date
//     });

//     loadDashboardData();
//   }, []);

//   useEffect(() => {
//     // Mock loading data from an API
//     setTimeout(() => setLoading(false), 300);

//     // Dispatching user type for example purposes
//     dispatch(setUserType("free"));

//     // Clean up body class on unmount
//     return () => {
//       document.body.classList.remove("dashboardPage");
//     };
//   }, [dispatch]);


//   const handleSaveName = (e) => {
//     e.preventDefault();
//     if (!firstName) {
//       alert('Please enter the first name');
//       return;
//     }

//     API({
//       method: 'POST',
//       url: 'update-name',
//       data: {
//         first_name: firstName,
//         last_name: lastName
//       }
//     })
//       .then(() => {
//         setShowUserNamePopup(false);  // close modal
//         loadDashboardData();          // reload user data
//       })
//       .catch(() => {
//         alert('Failed to update name. Please try again.');
//       });
//   };


//   return (
//     <>
//     <LaLoader show={loading || !dataLoaded} />
//       {!loading && (
//         <div className="siteContent p-0" style={{ height: "calc(100vh - 53px)" }}>
//           <DashboardHeader title="Dashboard" sutitle="PTE Core"/>
        
//           {/* <NavigationTour autoStart={true} onComplete={() => setStartDashboardTour(true)} /> */}
// {/* <DashboardTour autoStart={startDashboardTour} /> */}
//           <div className="dashboard-wrapper">  
//             <div className="row">            
           
//                 <NotificationArea
//                   loggedInUser={loggedInUser}
//                 />
           
             
//                 <StatCategories
//                   practiceData={practiceData}
//                   showAverageScore={parseInt(showAverageScore)}
//                 />
             
//             </div>
//             <div className="row mt-3">
              
//                 <Stats
//                   mockData={mockData}
//                   practiceData={practiceData}
//                   examDatePopup={examDatePopup}
//                   examPopupDate={examDate}
//                   loadDashboardData={loadDashboardData}
//                   estimatedScore={estimatedScore}
//                 />
            
//               <EstimatedExamScore
//                 estimatedScore={estimatedScore}
//                 sectional_estimated={sectional_estimated}
//               />
//               {/* <div className="col-md-6">
//                 <div className="dashboard-card section-2">
//                   <div className="plan-classes-section">
//                     <UserSubscriptions subscription={subscription} />

//                     {subscription.length > 0 &&
//                       <UpcomingClasses classes={classes} />
//                     }
//                   </div>
//                 </div>
//               </div> */}
//             </div>
//             <div className="dashboard-bottom-row">
//               <div className="row">
//                 <div className="col-xl-6 pr-xl-0">
//                   <UpcomingClasses
//                     classes={classes}
//                     showInPopup={false}
//                     sessionAcessExpiry={loggedInUser.session_expiry_date}
//                   />
//                 </div>

//                 <div className="col-xl-6" id="tour-tutorial-videos">
//                   <TuteVideos
//                     videos={portalVideos}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* <Modal
//             status={isTimezonePopup}
//             toggle={() => setIsTimezonePopup(false)}
//             showCloseBtn={false}
//             render={(toggle) => <TimezoneForm toggle={toggle} />}
//           /> */}

//           <Modal
//             status={showUserNamePopup}
//             toggle={() => { }}
//             showCloseBtn={false}
//             render={() => (
//               <form onSubmit={handleSaveName}>
//                 <div className="practice-shadowing-modal text-translate-modal user-name-update-modal p-4">
//                   <h4 className="mb-3 fw-bold">Update Your Name</h4>

//                   <div className="form-group mb-3">
//                     <label htmlFor="firstName" className="fw-semibold">
//                       First Name <span className="text-danger">*</span>
//                     </label>
//                     <input
//                       id="firstName"
//                       type="text"
//                       placeholder="Enter First Name"
//                       className="form-control"
//                       value={firstName}
//                       onChange={(e) => setFirstName(e.target.value)}
//                     />
//                   </div>

//                   <div className="form-group mb-4">
//                     <label htmlFor="lastName" className="fw-semibold">
//                       Last Name
//                     </label>
//                     <input
//                       id="lastName"
//                       type="text"
//                       placeholder="Enter Last Name"
//                       className="form-control"
//                       value={lastName}
//                       onChange={(e) => setLastName(e.target.value)}
//                     />
//                   </div>

//                   <button type="submit" className="btn btn-primary w-100">
//                     Save
//                   </button>
//                 </div>
//               </form>
//             )}
//           />
//         </div>
//       )}
//     </>
//   );
// });
// export default Dashboard;

import React, { useState, useEffect, memo } from "react";
import API from "api.js";
import { store } from "store/index";
import { useDispatch } from "react-redux";
import { setUserType, setUser } from "action";
import { Link } from "react-router-dom";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import NotificationArea from "components/Dashboard/New/NotificationArea";
import { fetchOnboardingData } from "components/WebsiteTour/tourData";
import { isTourCompleted } from "components/WebsiteTour/tourData";
// import CarRegistrationChart from "../components/Dashboard/DashboardChart";

import StatCategories from "components/Dashboard/New/StatCategories";
import Stats from "components/Dashboard/New/Stats";
import TuteVideos from "components/Dashboard/TuteVideos";
import EstimatedExamScore from "components/Dashboard/New/EstimatedExamScore";
import UserSubscriptions from "components/Dashboard/UserSubscriptions.jsx";
import UpcomingClasses from "components/Dashboard/UpcomingClasses.jsx";
import TimezoneForm from "components/Dashboard/TimezoneForm";
import Modal from "components/PopUps/Modal";
// import DashboardTour from "components/WebsiteTour/DashboardTourShepherd";
// import NavigationTour from "components/WebsiteTour/NavigationTourShepherd";
import LaLoader from "components/Loader/LaLoader";
import { BsArrowRightShort } from "react-icons/bs";
import "../assets/css/public-pages.css"

const Dashboard = memo(function Dashboard(props) {
  const [loading, setLoading] = useState(true);
  const [practiceData, setPracticeData] = useState(null);
  const [mockData, setMockData] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [portalVideos, setPortalVideos] = useState(null);
  const [showAverageScore, setShowAverageScore] = useState(false);
  const [estimatedScore, setEstimatedScore] = useState(0);
  const [sectional_estimated, setSectionalEstimated] = useState({});
  const [subscription, setSubscription] = useState([]);
  const [classes, setClasses] = useState([]);
  const [isTimezonePopup, setIsTimezonePopup] = useState(false);
  const [examDatePopup, setExamDatePopup] = useState(false);
  const [examDate, setExamDate] = useState(false);
  const [showUserNamePopup, setShowUserNamePopup] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [startDashboardTour, setStartDashboardTour] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const dispatch = useDispatch();

  const loadDashboardData = () => {
    API({
      method: 'GET',
      url: 'dashboard_data'
    }).then(res => {
      const { data, user, isClassified, branches, userType } = res.data;

      const {
        show_average_score,
        estimated_score,
        practice_data,
        mock_data,
        videos,
        classes,
        subscription,
        popup_video,
        sectional_estimated
      } = data;

      dispatch(setUser(user));
      setExamDatePopup(user.exam_date ? false : true)
      setExamDate(user.exam_date )
      setSectionalEstimated(sectional_estimated)
      setPracticeData(practice_data);
      setMockData(mock_data);
      setPortalVideos(videos);
      setShowAverageScore(show_average_score);
      setEstimatedScore(estimated_score);
      setSubscription(subscription);
      setClasses(classes);
      // setShowUserNamePopup(!user.first_name || !user.last_name);
      setShowUserNamePopup(!user.first_name);

      setFirstName(user.first_name || '');
      setLastName(user.last_name || '');
      const isTimezoneSaved = !user.user_timezone ? true : false;
      setIsTimezonePopup(isTimezoneSaved);


      // Set logged in user info
      let name = user.first_name
        ?  user.first_name
        // user.first_name + (user.last_name ? " " + user.last_name : "")
        : user.email;
      setLoggedInUser({
        name,
        email: user.email,
        active_subscription: user.active_subscription,
        session_expiry_date: user.session_expiry_date,
      });
       setDataLoaded(true);
    }).catch(err => {
      setDataLoaded(false);
      console.log(err)});
  }

  useEffect(() => {
    //  fetchOnboardingData(); 
    const { user: { first_name, last_name, email, active_subscription, session_expiry_date } } = store.getState();

    let name = first_name ? first_name : email;
    setLoggedInUser({
      name, email, active_subscription, session_expiry_date
    });

    loadDashboardData();
  }, []);

  useEffect(() => {
    // Mock loading data from an API
    setTimeout(() => setLoading(false), 300);

    // Dispatching user type for example purposes
    dispatch(setUserType("free"));

    // Clean up body class on unmount
    return () => {
      document.body.classList.remove("dashboardPage");
    };
  }, [dispatch]);


  const handleSaveName = (e) => {
    e.preventDefault();
    if (!firstName) {
      alert('Please enter the first name');
      return;
    }

    API({
      method: 'POST',
      url: 'update-name',
      data: {
        first_name: firstName,
        last_name: lastName
      }
    })
      .then(() => {
        setShowUserNamePopup(false);  // close modal
        loadDashboardData();          // reload user data
      })
      .catch(() => {
        alert('Failed to update name. Please try again.');
      });
  };


  return (
    <>
    <LaLoader show={loading || !dataLoaded} />
      {!loading && (
        <div className="siteContent p-0" style={{ height: "calc(100vh - 53px)" }}>
          <DashboardHeader title="Dashboard" sutitle="PTE Core"/>
        
          {/* <NavigationTour autoStart={true} onComplete={() => setStartDashboardTour(true)} /> */}
{/* <DashboardTour autoStart={startDashboardTour} /> */}
          <div className="dashboard-wrapper">  
            <div className="d-flex flex-column gap-3">            
           
                <NotificationArea
                  loggedInUser={loggedInUser}
                  mockData={mockData}
                  examDate={examDate}
                  setExamDate={setExamDate}
                  examDatePopup={examDatePopup}
                  loadDashboardData={loadDashboardData}
                />
             
                <StatCategories
                  practiceData={practiceData}
                  showAverageScore={parseInt(showAverageScore)}
                  mockData={mockData}
                  examDate={examDate}
                  setExamDate={setExamDate}
                  loadDashboardData={loadDashboardData}
                  examDatePopup={examDatePopup}
                />
             
            </div>
            <div className="d-flex flex-column gap-3 mt-3">
              
                <Stats
                  mockData={mockData}
                  practiceData={practiceData}
                  examDatePopup={examDatePopup}
                  examPopupDate={examDate}
                  loadDashboardData={loadDashboardData}
                  estimatedScore={estimatedScore}
                />
            
              {/* <EstimatedExamScore
                estimatedScore={estimatedScore}
                sectional_estimated={sectional_estimated}
              /> */}
            
            </div>
            <div className="dashboard-bottom-row">
              <div className="row">
                <div className="col-md-6 col-xl-6 pr-xl-0 d-flex flex-column gap-3">
                   <div className="dashboard-card microphone-card col-md-5 d-flex w-100 align-items-center m-0">
                    <h2 className="title m-0">Microphone Setup</h2>
                    <Link className="primary-btn text-center" to="/admin/mic-setup">Test Mic <BsArrowRightShort fontSize={"20px"}/></Link>
                    </div>
                  <UpcomingClasses
                    classes={classes}
                    showInPopup={false}
                    sessionAcessExpiry={loggedInUser.session_expiry_date}
                  />
                </div>
                 <EstimatedExamScore
                estimatedScore={estimatedScore}
                sectional_estimated={sectional_estimated}
              />
                {/* <div className="col-xl-6" id="tour-tutorial-videos">
                  <TuteVideos
                    videos={portalVideos}
                  />
                </div> */}
              </div>
            </div>
               <div  id="tour-tutorial-videos">
                  <TuteVideos
                    videos={portalVideos}
                  />
                </div>          </div>

          {/* <Modal
            status={isTimezonePopup}
            toggle={() => setIsTimezonePopup(false)}
            showCloseBtn={false}
            render={(toggle) => <TimezoneForm toggle={toggle} />}
          /> */}

          <Modal
            status={showUserNamePopup}
            toggle={() => { }}
            showCloseBtn={false}
            render={() => (
              <form onSubmit={handleSaveName}>
                <div className="practice-shadowing-modal text-translate-modal user-name-update-modal p-4">
                  <h4 className="mb-3 fw-bold">Update Your Name</h4>

                  <div className="form-group mb-3">
                    <label htmlFor="firstName" className="fw-semibold">
                      First Name <span className="text-danger">*</span>
                    </label>
                    <input
                      id="firstName"
                      type="text"
                      placeholder="Enter First Name"
                      className="form-control"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>

                  <div className="form-group mb-4">
                    <label htmlFor="lastName" className="fw-semibold">
                      Last Name
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      placeholder="Enter Last Name"
                      className="form-control"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>

                  <button type="submit" className="btn btn-primary w-100">
                    Save
                  </button>
                </div>
              </form>
            )}
          />
        </div>
      )}
    </>
  );
});
export default Dashboard;